export const useCasesData = {
  hrTeam: {
    problems: [
      'HR is overwhelmed with repeat questions from employees about policies, benefits, and procedures',
      'Policy and procedure answers are slow, inconsistent, or lost in email chains',
      'Employees lose trust when they get different answers from different HR team members',
      'HR spends 70% of their time answering basic questions instead of strategic work'
    ],
    solutions: [
      'Instant voice-access to policy, payroll, and HR queries with consistent, accurate responses',
      'Reduces HR workload by 60% by automating repetitive questions',
      'Built-in compliance awareness ensures answers align with current regulations',
      'Natural language understanding means employees can ask questions however they think of them'
    ],
    outcomes: [
      'Frees HR to focus on people strategy, not paperwork',
      'Improves employee experience and trust with consistent answers',
      'Reduces response time from hours to seconds',
      'Increases HR team satisfaction and reduces burnout'
    ],
    image: 'https://customer-assets.emergentagent.com/job_knowledge-voice/artifacts/8j7y3ihs_For%20HR%20Teams.png'
  },

  itTeam: {
    problems: [
      'Support teams waste hours answering the same IT and operational queries repeatedly',
      'Internal SOPs and technical documentation are scattered across different platforms',
      'Knowledge silos mean only certain team members know specific procedures',
      'Tickets pile up for questions that have documented answers somewhere'
    ],
    solutions: [
      'Lets staff self-serve answers without raising support tickets',
      'Smart AI understanding works even when questions are phrased imperfectly',
      'Consolidates knowledge from multiple sources into one voice-accessible system'
    ],
    outcomes: [
      'Reduces support ticket volume by 45% for common questions',
      'Enables faster resolution of complex issues by freeing up expert time',
      'Creates smarter knowledge management with usage analytics',
      'Improves team productivity and reduces time-to-resolution'
    ],
    image: 'https://images.unsplash.com/photo-1664382951070-70a6e4ef8ed0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxJVCUyMHN1cHBvcnQlMjB0ZWFtfGVufDB8fHx8MTc1MzIyMjY5Mnww&ixlib=rb-4.1.0&q=85'
  },

  executives: {
    problems: [
      'Poor visibility into how internal knowledge is accessed and used across the organization',
      'Missed opportunities for productivity improvements and operational efficiency',
      'Difficulty measuring ROI on internal documentation and knowledge management initiatives',
      'Lack of data-driven insights for strategic decision-making around operations'
    ],
    solutions: [
      'Usage analytics show what employees need most and identify knowledge gaps',
      'Brings measurable ROI to internal operations with detailed productivity metrics',
      'Aligns with digital transformation and AI adoption strategies',
      'Provides executive dashboard with key insights into organizational knowledge flow'
    ],
    outcomes: [
      'Improved strategic decision-making with data on knowledge usage patterns',
      'Quantifiable automation wins that demonstrate clear business value',
      'Better resource allocation based on actual employee needs and questions',
      'Competitive advantage through more efficient knowledge management'
    ],
    image: 'https://customer-assets.emergentagent.com/job_knowledge-voice/artifacts/p4qafvfo_For%20Executives%20%26%20Leadership.png'
  },

  healthcare: {
    problems: [
      'Medical staff waste precious time searching for protocols, drug information, and treatment guidelines',
      'Critical information delays can impact patient safety and care quality',
      'New staff struggle to quickly access complex medical procedures and compliance requirements',
      'Documentation scattered across multiple systems creates inefficiencies during busy shifts'
    ],
    solutions: [
      'Instant voice access to medical protocols, drug interactions, and treatment guidelines',
      'Hands-free operation perfect for sterile environments and busy medical settings',
      'Quick access to compliance requirements and regulatory updates'
    ],
    outcomes: [
      'Faster patient care with immediate access to critical information',
      'Improved patient safety through consistent, accurate medical guidance',
      'Reduced onboarding time for new medical staff',
      'Better compliance with medical regulations and protocols'
    ],
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NTMyMjIxNjB8MA&ixlib=rb-4.1.0&q=85'
  },

  retailHospitality: {
    problems: [
      'Customer service teams struggle with product information, policies, and troubleshooting procedures',
      'Staff training is inconsistent, leading to varied customer experiences',
      'High employee turnover means constant retraining on procedures and policies',
      'Customer inquiries overwhelm staff who lack immediate access to accurate information'
    ],
    solutions: [
      'Voice-powered access to product catalogs, return policies, and customer service scripts',
      'Consistent information delivery ensures uniform customer experiences',
      'Self-service training allows new employees to quickly get up to speed',
      'Multilingual support for diverse customer bases and international locations'
    ],
    outcomes: [
      'Improved customer satisfaction with faster, accurate responses',
      'Reduced training time and costs for new employees',
      'Consistent brand experience across all customer touchpoints',
      'Increased employee confidence and job satisfaction'
    ],
    image: 'https://customer-assets.emergentagent.com/job_knowledge-voice/artifacts/gcqglfu9_For%20Retail%20%26%20Hospitality.png'
  },

  financePayroll: {
    problems: [
      'Finance teams repeatedly answer payslip queries, tax code explanations, and benefits questions',
      'Employees struggle to understand complex payroll procedures and tax implications',
      'Accounting staff waste time on routine inquiries instead of financial analysis',
      'Inconsistent answers to financial policy questions create confusion and compliance risks'
    ],
    solutions: [
      'Instant voice access to payslip explanations, tax code details, and benefits information',
      'Automated responses to routine financial queries reduce workload on finance teams',
      'Consistent, accurate information ensures compliance with financial regulations',
      'Self-service capability for employees to get immediate answers to payroll questions'
    ],
    outcomes: [
      'Reduces finance team workload by 50% for routine inquiries',
      'Improves employee satisfaction with immediate payroll and tax information',
      'Ensures consistent compliance with financial regulations and policies',
      'Frees finance staff to focus on strategic financial planning and analysis'
    ],
    image: 'https://customer-assets.emergentagent.com/job_voice-ai-hub-1/artifacts/e3urxn93_For%20Finance%20%26%20Payroll.png'
  },

  legalCompliance: {
    problems: [
      'Legal teams constantly field policy lookup requests and compliance questions from employees',
      'Staff struggle to stay current with changing regulations and audit requirements',
      'Complex legal documents are difficult to navigate for non-legal team members',
      'Audit readiness is compromised when employees can\'t quickly access compliance information'
    ],
    solutions: [
      'Voice-powered policy lookups and instant access to compliance requirements',
      'Automated audit readiness checks and regulatory update notifications',
      'Plain-language explanations of complex legal and compliance topics',
      'Centralized access to all legal documents and policy updates'
    ],
    outcomes: [
      'Improved audit readiness with instant access to compliance information',
      'Reduced legal team workload for routine policy and compliance questions',
      'Better organizational compliance with faster access to regulatory requirements',
      'Enhanced employee confidence in handling compliance-related situations'
    ],
    image: 'https://customer-assets.emergentagent.com/job_voice-ai-hub-1/artifacts/s9qzs3mj_For%20Legal%20%26%20Compliance.png'
  },

  universities: {
    problems: [
      'Student service teams are overwhelmed with repetitive questions about visa requirements, immigration procedures, and accommodation options',
      'International students struggle to navigate complex university systems and policies in multiple languages',
      'Career services and employability teams spend excessive time answering the same job search and graduate scheme questions',
      'Admissions and student support staff answer identical queries about application processes, deadlines, and requirements daily'
    ],
    solutions: [
      'Instant voice access to visa requirements, immigration procedures, and application deadlines in multiple languages',
      'Automated responses to accommodation enquiries, campus facilities, and student services information',
      'Self-service access to employability resources, job search guidance, and graduate program information',
      'Consistent, up-to-date information about university policies, academic regulations, and student support services'
    ],
    outcomes: [
      'Reduces student services workload by 65% for routine visa and immigration enquiries',
      'Improves international student experience with instant multilingual support',
      'Frees career services staff to focus on personalized guidance and employer partnerships',
      'Enhances student satisfaction with 24/7 access to university information and support'
    ],
    image: 'https://customer-assets.emergentagent.com/job_vioq-error-fix/artifacts/xc8z6ayi_University%20Students.png'
  },

  comparisonTable: [
    {
      benefit: 'Instant Answer Delivery',
      hr: true,
      it: true,
      executives: false,
      healthcare: true,
      retail: true,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'Reduced Workload',
      hr: true,
      it: true,
      executives: false,
      healthcare: true,
      retail: true,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'Usage Analytics & Insights',
      hr: false,
      it: true,
      executives: true,
      healthcare: false,
      retail: false,
      finance: false,
      legal: false,
      universities: true
    },
    {
      benefit: 'Compliance & Consistency',
      hr: true,
      it: false,
      executives: true,
      healthcare: true,
      retail: true,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'System Integration',
      hr: false,
      it: true,
      executives: false,
      healthcare: true,
      retail: false,
      finance: false,
      legal: false,
      universities: true
    },
    {
      benefit: 'Self-Service Capability',
      hr: true,
      it: true,
      executives: false,
      healthcare: true,
      retail: true,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'Strategic ROI Measurement',
      hr: false,
      it: false,
      executives: true,
      healthcare: false,
      retail: false,
      finance: false,
      legal: false,
      universities: false
    },
    {
      benefit: '24/7 Availability',
      hr: true,
      it: true,
      executives: false,
      healthcare: true,
      retail: true,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'Multilingual Support',
      hr: false,
      it: false,
      executives: false,
      healthcare: false,
      retail: true,
      finance: false,
      legal: false,
      universities: true
    },
    {
      benefit: 'Hands-Free Operation',
      hr: false,
      it: false,
      executives: false,
      healthcare: true,
      retail: false,
      finance: false,
      legal: false,
      universities: false
    },
    {
      benefit: 'Policy & Regulation Access',
      hr: true,
      it: false,
      executives: false,
      healthcare: true,
      retail: false,
      finance: true,
      legal: true,
      universities: true
    },
    {
      benefit: 'Audit Readiness',
      hr: false,
      it: false,
      executives: false,
      healthcare: false,
      retail: false,
      finance: true,
      legal: true,
      universities: false
    }
  ]
};